"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCard = exports.SmartHeader = exports.ProductList = exports.PortraitVideo = exports.InformationCard = exports.Header = exports.GridForm = exports.FancyFooter = exports.Footer = exports.BasicCard = exports.BasicSlider = exports.BannerWithCard = exports.BasicBanner = exports.BasicForm = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

require("bootstrap/dist/css/bootstrap.min.css");

require("./styles/global.css");

var _components = require("./components");

var _baseHelper = require("./helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDefaultProps = _baseHelper2.default.getDefaultProps;
// import { ThreeEqualWidthColumn } from "./layouts";

var thumbnailImage = "https://ik.imagekit.io/marketcube/platform/storybook";

exports.BasicForm = _components.BasicForm;
exports.BasicBanner = _components.BasicBanner;
exports.BannerWithCard = _components.BannerWithCard;
exports.BasicSlider = _components.BasicSlider;
exports.BasicCard = _components.BasicCard;
exports.Footer = _components.Footer;
exports.FancyFooter = _components.FancyFooter;
exports.GridForm = _components.GridForm;
exports.Header = _components.Header;
exports.InformationCard = _components.InformationCard;
exports.PortraitVideo = _components.PortraitVideo;
exports.ProductList = _components.ProductList;
exports.SmartHeader = _components.SmartHeader;
exports.VideoCard = _components.VideoCard;

var exportOBJ = {
  // Headers
  header: {
    name: "header",
    props: getDefaultProps("header"),
    thumbnail: thumbnailImage + "/header.png",
    groupId: "headers"
  },
  smartHeader: {
    name: "smartHeader",
    props: getDefaultProps("smartHeader"),
    thumbnail: thumbnailImage + "/smart-header.png",
    groupId: "headers"
  },
  //-----------------------------------------------------
  //                     Banners
  //-----------------------------------------------------
  basicBanner: {
    name: "basicBanner",
    props: getDefaultProps("basicBanner"),
    thumbnail: thumbnailImage + "/banner.png",
    groupId: "banners"
  },
  bannerWithCard: {
    name: "bannerWithCard",
    props: getDefaultProps("bannerWithCard"),
    thumbnail: thumbnailImage + "/banner-card.png",
    groupId: "banners"
  },

  //-----------------------------------------------------
  //                    Media Cards
  //-----------------------------------------------------
  basicCard: {
    name: "basicCard",
    props: getDefaultProps("basicCard"),
    thumbnail: thumbnailImage + "/basic-media-card.png",
    groupId: "media cards"
  },
  informationCard: {
    name: "informationCard",
    props: getDefaultProps("informationCard"),
    thumbnail: thumbnailImage + "/product-detail.png",
    groupId: "media cards"
  },
  portraitVideo: {
    name: "portraitVideo",
    props: getDefaultProps("portraitVideo"),
    thumbnail: thumbnailImage + "/portrait-video.png",
    groupId: "media cards"
  },

  videoCard: {
    name: "videoCard",
    props: getDefaultProps("videoCard"),
    thumbnail: thumbnailImage + "/video-card.png",
    groupId: "media cards"
  },
  //-----------------------------------------------------
  //                     Sliders
  //-----------------------------------------------------
  basicSlider: {
    name: "basicSlider",
    props: getDefaultProps("basicSlider"),
    thumbnail: thumbnailImage + "/slider.png",
    groupId: "slider"
  },
  //-----------------------------------------------------
  //                     product List
  //-----------------------------------------------------
  productList: {
    name: "productList",
    props: getDefaultProps("productList"),
    thumbnail: thumbnailImage + "/product-listing.png",
    groupId: "productList"
  },
  //-----------------------------------------------------
  //                        Forms
  //-----------------------------------------------------
  basicForm: {
    name: "basicForm",
    props: getDefaultProps("basicForm"),
    thumbnail: thumbnailImage + "/basic-form.png",
    groupId: "forms"
  },
  gridForm: {
    name: "gridForm",
    props: getDefaultProps("gridForm"),
    thumbnail: thumbnailImage + "/grid-form.png",
    groupId: "forms"
  },
  //-----------------------------------------------------
  //                       Footer
  //-----------------------------------------------------
  footer: {
    name: "footer",
    props: getDefaultProps("footer"),
    thumbnail: thumbnailImage + "/footer.png",
    groupId: "footers"
  },
  // Fancy footer
  fancyFooter: {
    name: "fancyFooter",
    props: getDefaultProps("fancyFooter"),
    thumbnail: thumbnailImage + "/fancy-foote.png",
    groupId: "footers"
  }

  // Layouts
  // threeEqualWidthColumn: {
  //   name: "threeEqualWidthColumn",
  //   props: getDefaultProps("threeEqualWidthColumn"),
  //   thumbnail: `${thumbnailImage}/3-col.png`,
  //   groupId: "layout",
  // },
};

if (process.env.REACT_APP_TEST_MODE) {
  try {
    import("./App.js").then(function (module) {
      var App = module.default;
      _reactDom2.default.render(_react2.default.createElement(App, null), document.getElementById("root"));
    }).catch(function (err) {});
  } catch (error) {}
}

exports.default = exportOBJ;